export default "__VITE_ASSET__8da324ad__"